(function () {
    class LocalDistributor extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                overlay: "#local-overlay",
                content: "#local-content",
                close: "#local-close",
                inner: "#local-inner",
                templates: "#local-templates",
                storeLinks: ".local-inner__footer-link"
            };
            this.triggerElements = document.querySelectorAll(`${this.selectors.overlay}, ${this.selectors.close}`);
        }

        connectedCallback() {
            this.init();


            this.triggerElements.forEach(element => element.addEventListener("click", () => {
                this.handleToggleModal.bind(this)();
                this.recordValueCookie("modal", "show")
            }))
        }


        handleToggleModal() {
            const isShowModal = this.readValueCookie("modal");
            console.log(isShowModal);
            
            if (isShowModal) return;
            const isActive = !this.classList.contains("local-distributor--active");
            this.classList.toggle("local-distributor--active", isActive);
        }

        async init() {
            try {
                const isoCode = await this.getCurrentCountry();
                if (isoCode) {
                    const content = this.getContentFromTemplate(isoCode);
                    if (content) this.insertContent(content);
                }
            } catch (error) {
                console.error("Error initializing LocalDistributor:", error);
            }
        }

        recordValueCookie(key, message) {
            document.cookie = `${key}=${encodeURIComponent(message)}; path=/`;
        }

        readValueCookie(key) {
            const cookies = document.cookie.split('; ');
            for (const cookie of cookies) {
                const [cookieKey, cookieValue] = cookie.split('=');
                if (cookieKey === key) {
                    return decodeURIComponent(cookieValue);
                }
            }
            return false;
        }


        getContentFromTemplate(isoCode) {
            const template = this.querySelector(`${this.selectors.templates} template#${isoCode}`);
            return template ? [...template.content.cloneNode(true).children] : null;
        }

        insertContent(htmlContent) {
            const innerElement = document.querySelector(this.selectors.inner);
            if (!innerElement) return;

            innerElement.innerHTML = "";
            innerElement.append(...htmlContent);
            this.removeAttribute("hidden");
            this.handleToggleModal();

            document.querySelectorAll(`${this.selectors.storeLinks}`).forEach(link => {
                link.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.handleToggleModal();
                    this.recordValueCookie("modal", "show");
                    if (link.id === "local-link-store") {
                        window.location.href = link.href;
                    } else {
                        window.open(link.href, "_blank");
                    }

                })
            })


        }

        async getCurrentCountry() {
            try {
                const response = await fetch("/browsing_context_suggestions");
                if (!response.ok) throw new Error("Failed to fetch country data");

                const data = await response.json();
                return data?.detected_values?.country?.handle || null;
            } catch (error) {
                console.error("Error fetching country data:", error);
                return null;
            }
        }
    }

    customElements.define("local-distributor", LocalDistributor);
})();
